export const CHANGE_LOCALE = 'CHANGE_LOCALE';

export const LOGIN_USER_FACEBOOK = 'LOGIN_USER_FACEBOOK';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_EMAIL_PASSWORD_FIREBASE = 'LOGIN_USER_EMAIL_PASSWORD_FIREBASE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FACEBOOK_SUCCESS = 'LOGIN_USER_FACEBOOK_SUCCESS';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_USER_BOT_TOKEN = 'UPDATE_USER_BOT_TOKEN';
export const UPDATE_USER_FB_TOKEN = 'UPDATE_USER_FB_TOKEN';
export const SET_ACCESS_LEVEL = 'SET_ACCESS_LEVEL';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';